import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { STUDY_CHANGE_POPUP_HEADING, STUDY_CHANGE_POPUP_SECOND_HEADING } from "./GeoMapConstant";
import { getInvalidPopupLabels } from '../../util/geomapUtils';
import GenericButton from '../common/GenericButton';

class GeoMapStudyChangePopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <div className="text-center">
          <div>
            <div className="study-change-popup-heading">{STUDY_CHANGE_POPUP_HEADING}<br />
              {STUDY_CHANGE_POPUP_SECOND_HEADING}
            </div>
            <div className="study-change-block">
              {map(this.props.studyChangeInvalidData, obj => {
                return (
                  <div className="study-change-tab-block">
                    <div className="study-change-popup-tab-label">{getInvalidPopupLabels(obj.selectedTab)}:</div>
                    {obj.data !== undefined &&
                    map(obj.data, obj => {
                      return (
                        <div className="study-change-invalid-data-point-name">{obj.n}</div>
                    );
                    })}
                    {obj.data === undefined &&
                      <div className="study-change-invalid-data-point-name">{obj.name}</div>
                }
                  </div>
                  );
              })}
            </div>
          </div>
          <div className="study-change-popup-button">
            <GenericButton
              name="Cancel"
              btnStyle="button btn-cncl button-80px study-change-popup-cancel"
              onBtnClick={() => {
                this.props.handleCancelClickOnStudyChange();
              }}
            />
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-80px float-right study-change-popup-cancel"
              onBtnClick={() => {
                this.props.handleValidateContinueClickOnStudyChange();
              }}
            />
          </div>
          <div>&nbsp;</div>
        </div>
      </div>
    );
  }
}

GeoMapStudyChangePopup.propTypes = {
  studyChangeInvalidData: PropTypes.arrayOf(PropTypes.object),
  handleCancelClickOnStudyChange: PropTypes.func,
  handleValidateContinueClickOnStudyChange: PropTypes.func,
};

export default GeoMapStudyChangePopup;
